import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import { Button, Typography } from '@sm-dashboard/ui-components';
import ErrorIcon from '@mui/icons-material/Error';
import { publicBusinessAdsUrl } from '@/constants';
import instanceAxios from '@/util/axios';

const BusinessAdPaymentError: React.FC = () => {
  const navigate = useNavigate();
  const { adId } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // If this is a business ad payment error, send error data to webhook
    if (adId) {
      const errorData = {
        LowProfileId: searchParams.get('lowprofilecode'),
        TranzactionId: searchParams.get('TranzactionId'),
        ReturnValue: adId,
        TranzactionInfo: {
          ResponseCode: parseInt(searchParams.get('ResponseCode') || '1'),
          ApprovalNumber: searchParams.get('ApprovalNumber'),
          DocumentNumber: searchParams.get('DocumentNumber'),
          DocumentUrl: searchParams.get('DocumentUrl'),
          Description: searchParams.get('Description') || 'Payment failed'
        }
      };

      // Send error data to business ads webhook
      instanceAxios.post(`${publicBusinessAdsUrl}/payment-webhook`, errorData).catch(console.error);
    }
  }, [adId, searchParams]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <ErrorIcon sx={{ fontSize: 80, color: 'error.main' }} />
      <Box sx={{ mb: '0.35em' }}>
        <Typography variant="h3">התשלום נכשל</Typography>
      </Box>
      <Box sx={{ mb: '0.35em' }}>
        <Typography variant="body2" color="text.secondary">
          מצטערים, התשלום לא יכול להתבצע. אנא נסה שוב או פנה לתמיכה אם הבעיה נמשכת.
        </Typography>
      </Box>
      <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
        <Button onClick={() => navigate('/business-ads/submit/publisher')}>נסה שוב</Button>
      </Box>
    </Container>
  );
};

export default BusinessAdPaymentError;
